import { render } from "./InputDate.vue?vue&type=template&id=3b8ba0c0&ts=true"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"

import "./InputDate.vue?vue&type=style&index=0&id=3b8ba0c0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__